import { useTranslation } from 'react-i18next';

interface ConsentBadgeProps {
  status: string;
  showDetails?: boolean;
  responseText?: string | null;
  responseTimestamp?: string | null;
}

const statusColors: Record<string, string> = {
  not_requested: 'bg-gray-100 text-gray-600',
  opt_in_requested: 'bg-yellow-100 text-yellow-700',
  approved: 'bg-green-100 text-green-700',
  rejected: 'bg-red-100 text-red-700',
  opted_out: 'bg-red-100 text-red-700',
  invalid_phone: 'bg-orange-100 text-orange-700',
  failed: 'bg-red-100 text-red-700',
};

const statusIcons: Record<string, string> = {
  not_requested: '⚪',
  opt_in_requested: '⏳',
  approved: '✅',
  rejected: '❌',
  opted_out: '🚫',
  invalid_phone: '⚠️',
  failed: '❗',
};

export default function ConsentBadge({
  status,
  showDetails = false,
  responseText,
  responseTimestamp,
}: ConsentBadgeProps) {
  const { t } = useTranslation();
  const colors = statusColors[status] ?? 'bg-gray-100 text-gray-600';
  const icon = statusIcons[status] ?? '⚪';

  return (
    <div className="inline-flex flex-col gap-1">
      <span
        className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${colors}`}
      >
        <span>{icon}</span>
        <span>{t(`whatsappConsent.status.${status}`, status)}</span>
      </span>
      {showDetails && responseText && (
        <span className="text-xs text-gray-500">
          &quot;{responseText}&quot;
          {responseTimestamp && (
            <span className="ltr:ml-1 rtl:mr-1">
              ({new Date(responseTimestamp).toLocaleDateString()})
            </span>
          )}
        </span>
      )}
    </div>
  );
}
